import {gql} from 'graphql-request';
import {useMutation} from '@tanstack/react-query';
import {MutationOptions} from './interface';
import {useGqlRequest} from './request';

export const useUserOpinionCreateOne = (options?: MutationOptions) => {
  const request = useGqlRequest({
    query: USER_OPINION_CREATE_ONE,
  });

  const mutationFn = (record: {
    newAddress?: string;
    addressOpinion?: string;
    etcOpinion?: string;
  }) => {
    return request(record);
  };

  return useMutation({
    mutationKey: ['user-opinion'],
    ...options,
    mutationFn,
  });
};

const USER_OPINION_CREATE_ONE = gql`
  mutation createUserOpinion(
    $newAddress: String
    $addressOpinion: String
    $etcOpinion: String
  ) {
    result: createUserOpinion(
      newAddress: $newAddress
      addressOpinion: $addressOpinion
      etcOpinion: $etcOpinion
    ) {
      code
      message
      success
    }
  }
`;
